import dayjs, { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const DEFAULT_GRAVITY_DATE_FORMAT = 'dmy'

const DATE_FORMAT_MAP: Record<string, string> = {
  dmy: 'DD/MM/YYYY',
  mdy: 'MM/DD/YYYY',
  ymd: 'YYYY-MM-DD'
}

export const getDayjsDateFormatFromGravity = (dateFormat?: string | null): string => {
  const normalized = (dateFormat || DEFAULT_GRAVITY_DATE_FORMAT).toLowerCase()
  return DATE_FORMAT_MAP[normalized] || DATE_FORMAT_MAP[DEFAULT_GRAVITY_DATE_FORMAT]
}

export const parseGravityDateValue = (
  value?: string | null,
  dateFormat?: string | null
): Dayjs | null => {
  if (!value) return null

  const expectedFormat = getDayjsDateFormatFromGravity(dateFormat)

  // Try strict parsing with Gravity format first, then fallback to ISO-like formats.
  const parsedByFormat = dayjs(value, expectedFormat, true)
  if (parsedByFormat.isValid()) return parsedByFormat

  const parsedIso = dayjs(value, ['YYYY-MM-DD', 'YYYY/MM/DD'], true)
  if (parsedIso.isValid()) return parsedIso

  const parsedLoose = dayjs(value)
  return parsedLoose.isValid() ? parsedLoose : null
}

export const formatGravityDateValue = (value: Dayjs, dateFormat?: string | null): string => {
  return value.format(getDayjsDateFormatFromGravity(dateFormat))
}
